import { Component, Vue } from 'vue-property-decorator'
@Component({})
export default class ChannelMixin extends Vue {
  public SAchannel: any = ''

  public created() {
    // 设置channel
    const channel = this.$route.query._c
    const storeChannel = this.$store.state.channel
    // 如果 url 中存在 _c ，那么直接设置为，公共参数 channel ，如果不存在，首先查看store中是否存在
    if (channel) {
      this.SAchannel = channel
      this.$store.commit('SET_CHANNEL', channel)
    } else {
      if (storeChannel) {
        this.SAchannel = storeChannel
      } else {
        this.SAchannel = ''
      }
    }
  }
}
